<template>
  <v-dialog @input="close" :value="isOpened" max-width="800px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="font-weight-bold">
          {{ dialogTitle }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-3">
        <v-form ref="form">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="updates.name"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.name')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="updates.description"
                  :disabled="isLoading"
                  :label="$t('miscellaneous.description')"
                  auto-grow
                  rows="2" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.address1"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.address1')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.address2"
                  :disabled="isLoading"
                  :label="$t('generalAttributes.address2')" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.postcode"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.postalCode')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.city"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.city')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.state"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.state')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.country"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.country')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.email"
                  :disabled="isLoading"
                  :label="$t('generalAttributes.email')"
                  hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="updates.phone"
                  :disabled="isLoading"
                  :label="$t('generalAttributes.phone')"
                  hide-details />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn @click="close" text class="ml-2">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
          class="mr-2"
          color="primary">
          {{ $t('miscellaneous.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const resetUpdates = (data = {}) => ({
  id: data.id || '',
  name: data.name || '',
  description: data.description || '',
  address1: data.address1 || '',
  address2: data.address2 || '',
  postcode: data.postcode || '',
  city: data.city || '',
  state: data.state || '',
  country: data.country || '',
  phone: data.phone || '',
  email: data.email || '',
})

export default {
  name: 'SupplierUpsertDialog',
  props: {
    supplier: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
    isOpened: { type: Boolean, required: true },
  },
  data() {
    return {
      updates: resetUpdates(),
    }
  },
  computed: {
    dialogTitle() {
      return this.supplier.id
        ? this.$t('entities.suppliers.editEntity')
        : this.$t('entities.suppliers.newEntity')
    },
    requiredStringRule() {
      return (v) =>
        (!!v && v.length >= 1 && v.length <= 256) ||
        'Required (1-256 characters).'
    },
  },
  methods: {
    buildPayload() {
      const payload = { ...this.updates }
      Object.keys(payload).forEach((field) => {
        if (typeof payload[field] === 'string')
          payload[field] = payload[field].trim()
      })
      const unRequiredFields = ['address2', 'description', 'phone', 'email']
      unRequiredFields.forEach((field) => {
        if (payload[field] === '') {
          payload[field] = null
        }
      })
      return payload
    },
    close() {
      return this.$emit('dialog:close')
    },
    onClose() {
      this.updates = resetUpdates()
      this.resetForm()
    },
    onOpen() {
      this.resetForm()
      this.updates = resetUpdates(this.supplier)
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.reset()
    },
    submit() {
      if (!this.$refs.form || !this.$refs.form.validate()) return
      return this.$emit('supplier:upsert', this.buildPayload())
    },
  },
  watch: {
    isOpened(value) {
      return value ? this.onOpen() : this.onClose()
    },
  },
}
</script>
